import { type Abi, erc20Abi } from "viem";

export const usdtAbi = [
  ...erc20Abi,
  {
    type: "function",
    name: "approve",
    stateMutability: "nonpayable",
    inputs: [
      {
        name: "spender",
        type: "address",
      },
      {
        name: "amount",
        type: "uint256",
      },
    ],
    outputs: [],
  },
] as Abi;
